import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { addReqiredMessage } from '@/components/slides/DataSummary/util/addRequiredMessage.ts';
import { useForm } from '@/form/useForm.ts';
import { useEffect } from 'react';

export const ContactSummaryFormIN = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({
    slideIds: ['email', 'phone'],
  });

  const { getFieldValue, onChange } = useForm();

  useEffect(() => {
    const whatsapp = getFieldValue('whatsApp');
    if (!whatsapp) {
      onChange('whatsApp', {
        value: { raw: false, normalized: false },
        isValid: true,
        hint: undefined,
        slideId: 'phone',
      });
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  const emailField = addReqiredMessage({
    field: s.email.fields.find(({ name }) => name === 'email'),
    message: s.dataSummary.requiredMessage!,
  });
  const emailLabel = translate(emailField?.label);

  const mobileField = addReqiredMessage({
    field: s.phone.fields.find(({ name }) => name === 'mobile'),
    message: s.dataSummary.requiredMessage!,
  });
  const mobileLabel = translate(mobileField?.label);

  const phoneField = addReqiredMessage({
    field: s.phone.fields.find(({ name }) => name === 'phone'),
    message: s.dataSummary.requiredMessage!,
  });
  const phoneLabel = translate(phoneField?.label);

  return (
    <div className="summary-card" data-cy={'summary-form-contact'}>
      <h2>{translate(s.dataSummary.titles?.contact)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{emailLabel}</div>
        <div className={'value'}>
          {getFieldValue('email')}
          {
            <div style={{ display: 'none' }}>
              <EditDataField field={emailField!} slideId={'email'} />
            </div>
          }
        </div>
        <div className={'label'}>{mobileLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('mobile')}
          {editMode && <EditDataField field={mobileField!} slideId={'phone'} />}
        </div>
        <div className={'label'}>{phoneLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('phone')}
          {editMode && <EditDataField field={phoneField!} slideId={'phone'} />}
        </div>
      </div>
    </div>
  );
};
